<ng-container *ngFor="let entry of dynamicFormEntries">
  <ui-generic-form-entry [dynamicFormEntry]="entry"
                         [form]="form">
  </ui-generic-form-entry>
</ng-container>
